// Realiza los cambios necesarios para que los textos descriptivos de StoryBook se muestren correctamente
export const parseStorybookText = (value: string): string => {
  return value.replaceAll('|', '\uFF5C');
};
